import { Clock, Globe } from "lucide-react"
import styles from "./Forms.module.css"
import Footer from "../../components/Shared/Footer"
import board from "assets/images/svg/Mask group.svg";
import Members from "assets/images/svg/Mask group (1).svg";
import circle from "assets/images/svg/Ellipse 5.svg";
import icon from "assets/images/svg/Group 29 (2).svg";

const Forms = () => {
  return (
    <div>
      <div className={styles.Forms}>
        <h1 className={styles.title}>All Forms</h1>

        <div className={styles.cardContainer}>
          {/* Heads Recruitment Card */}
          <a href="/Submit" className={styles.cardLink}>
            <div className={styles.card}>
              <div className={styles.imageContainer}>
                <img
                  src={board}
                  alt="Heads Recruitment"
                  className={styles.cardImage}
                />
              </div>

              <h2 className={styles.cardTitle}>Season 2025 - Heads Recruitment</h2>

              <div className={styles.cardInfo}>
                <div className={styles.infoItem}>
                  <Globe className={styles.icon} />
                  <span>Board</span>
                </div>
                <div className={styles.infoItem}>
                  <Clock className={styles.icon} />
                  <span>2025</span>
                </div>
              </div>

              <div className={styles.menuIcon}>
                <img
                  src={circle}
                  alt="Menu Background"
                  className={styles.menuBackground}
                />
                <img
                  src={icon}
                  alt="Menu Icon"
                  className={styles.menuForeground}
                />
              </div>
            </div>
          </a>

          {/* Members Recruitment Card */}
          <a href="/Submit" className={styles.cardLink}>
            <div className={styles.card}>
              <div className={styles.imageContainer}>
                <img
                  src={Members}
                  alt="Members Recruitment"
                  className={styles.cardImage}
                />
              </div>

              <h2 className={styles.cardTitle}>Season 2025 - Members Recruitment</h2>

              <div className={styles.cardInfo}>
                <div className={styles.infoItem}>
                  <Globe className={styles.icon} />
                  <span>Committees</span>
                </div>
                <div className={styles.infoItem}>
                  <Clock className={styles.icon} />
                  <span>2025</span>
                </div>
              </div>

              <div className={styles.menuIcon}>
                <img
                  src={circle}
                  alt="Menu Background"
                  className={styles.menuBackground}
                />
                <img
                  src={icon}
                  alt="Menu Icon"
                  className={styles.menuForeground}
                />
              </div>
            </div>
          </a>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Forms

